import { render } from "./RPanel.vue?vue&type=template&id=f6f1d0f4"
import script from "./RPanel.vue?vue&type=script&lang=js"
export * from "./RPanel.vue?vue&type=script&lang=js"

import "./RPanel.vue?vue&type=style&index=0&id=f6f1d0f4&lang=css"
script.render = render

export default script